export default __webpack_public_path__ + "static/media/Ficha Técnica - Suco de Abacaxi Concentrado Congelado - 60°BRIX.c989bdea.pdf";